<rt-dialog-header
  [heading]="'tlc.positions.import_skills_flow.upload_file.heading' | translate"
  [subheading]="'tlc.positions.import_skills_flow.upload_file.subheading' | translate"
/>

<rt-dialog-body variant="white">
  @if (status() === 'failed') {
    <div class="loading-status-container">
      <rt-icon name="warning" />
      <span class="status">{{ failureReason() }}</span>
    </div>
  } @else {
    <div class="loading-status-container">
      <rt-spinner />
      <span class="status">{{
        'tlc.positions.import_skills_flow.loading_dialog.loading_status.status' | translate
      }}</span>
      <span class="description">{{
        'tlc.positions.import_skills_flow.loading_dialog.loading_status.description' | translate
      }}</span>
    </div>
    <rt-loading-game-frame
      [startText]="gameStartText"
      [tutorialText]="gameTutorialText"
      [gameOverText]="gameOverText"
      [scoreText]="gameScoreText"
    />
  }
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true" innerPadding="small">
  <div class="optional">
    @if (status() !== 'processing') {
      <rt-button variant="plain" (click)="back()">
        <rt-icon name="arrow-back" />
        <span>{{ 'tlc.common.back' | translate }}</span>
      </rt-button>
    }
  </div>
</rt-dialog-footer>
